import { computed } from 'vue';
import { useStore } from 'vuex';

// 显示提交人信息
export var useCommiterInfo = function useCommiterInfo() {
  var store = useStore();
  // 是否显示提交人信息
  var showCommiter = computed(function () {
    // 只有登录了 而且infoStatus为2的时候显示
    return store.getters.getToken && store.getters.getQuesInfo.infoStatus === 2;
  });
  return {
    showCommiter: showCommiter
  };
};